import React from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import * as R from 'ramda';
import { ModalCivil } from './modals/modalCivil';

export const Civil = ({deathDeclaration, userId, isLoading}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    let parsedMobilePhoneNumber = undefined;
    if(!deathDeclaration.phoneNumber.startsWith("+00")){
        if(!R.isNil(deathDeclaration.phoneNumber) && deathDeclaration.phoneNumber !== ""){
            const parsedPhoneNumber = parsePhoneNumber(deathDeclaration.phoneNumber);
            if(!R.isNil(parsedPhoneNumber)){
                parsedMobilePhoneNumber = parsedPhoneNumber.formatInternational();
            }
        }
    }
    return (
        <section className="card mb-sm">
            {/*  If card is not active replace: 
                                    1. in card title " text-secondary" with " text-gray"
                                    2. remove checked from switch
                            */}
            <div className="card-header pb-0">
                <div className="grid grid-sm-2 align-items-center">
                    <h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">Informations du défunt</h2>
                    <div className="grid grid-2 ml-sm-auto align-items-center">
                        <button type="button" data-toggle="modal" data-target="#civilModal" className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button>
                        <div className="custom-control custom-switch mx-auto">
                            <input type="checkbox" className="custom-control-input" id="civilSwitchCheckDefault" required="required"  defaultChecked={deathDeclaration.onBoardingStep > 3} />
                            <label className="custom-control-label" htmlFor="civilSwitchCheckDefault">Valider</label>
                        </div>
                    </div>
                </div>
                <hr className="mb-0" />
            </div>
            <div className="card-body flex-row col-10 justify-content-between g-2">
                <div className="block">
                    <h3 className="h6 font-weight-bold">Nom</h3>
                    <p className="h5">{deathDeclaration.lastName}</p>
                </div>
                <div className="block">
                    <h3 className="h6 font-weight-bold">Prénom</h3>
                    <p className="h5">{deathDeclaration.firstName}</p>
                </div>
                <div className="block">
                    <h3 className="h6 font-weight-bold">Date de naissance</h3>
                    <p className="h5">{deathDeclaration.birthDate.toLocaleDateString('fr-FR')}</p>
                </div>
                <div className="block">
                    <h3 className="h6 font-weight-bold">Pays</h3>
                    <p className="h5">{countries.getName(deathDeclaration.country, "fr", { select: "official" })}</p>
                </div>
                <div className="block">
                    <h3 className="h6 font-weight-bold">Téléphone fixe</h3>
                    <p className="h5">{deathDeclaration.userResidenceAddress.phoneNumber === "" ? "N/D" : deathDeclaration.userResidenceAddress.phoneNumber}</p>
                </div>
                {
                    R.isNil(parsedMobilePhoneNumber) ?
                        ''
                    :
                        <div className="block">
                            <h3 className="h6 font-weight-bold">Mobile</h3>
                            <p className="h5">{parsedMobilePhoneNumber}</p>
                        </div>
                }
                
                <div className="block">
                    <h3 className="h6 font-weight-bold">Invalide</h3>
                    <p className="h5 o-60">{deathDeclaration.isInvalid ? "Oui" : "Non"}</p>
                </div>
            </div>
            {/* <div className="card-footer">
                <hr className="mt-0" />
                <div className="flex-row align-items-center">
                    <h2 className="h4 text-uppercase o-70 font-weight-bolder my-auto">Invalide</h2>
                    <span className="h5 font-weight-bold my-auto ml-auto o-40">{deathDeclaration.isInvalid ? "Oui" : "Non"}</span>
                </div>
            </div> */}
            <ModalCivil deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
        </section>
    )
}